import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook, FaTwitter, FaInstagram, FaYoutube,
  FaLinkedin, FaTiktok, FaTelegram, FaWhatsapp,
  FaReddit, FaPinterest, FaSnapchat, FaMedium, FaGlobe
} from "react-icons/fa";

const BASE_URL = "https://api.dreamtoday.in";

/* Map platform name → icon component */
const ICON_MAP = {
  facebook: { icon: FaFacebook, color: "hover:text-blue-500" },
  twitter: { icon: FaTwitter, color: "hover:text-sky-400" },
  instagram: { icon: FaInstagram, color: "hover:text-pink-500" },
  youtube: { icon: FaYoutube, color: "hover:text-red-500" },
  linkedin: { icon: FaLinkedin, color: "hover:text-blue-400" },
  tiktok: { icon: FaTiktok, color: "hover:text-white" },
  telegram: { icon: FaTelegram, color: "hover:text-sky-400" },
  whatsapp: { icon: FaWhatsapp, color: "hover:text-green-400" },
  reddit: { icon: FaReddit, color: "hover:text-orange-500" },
  pinterest: { icon: FaPinterest, color: "hover:text-red-400" },
  snapchat: { icon: FaSnapchat, color: "hover:text-yellow-300" },
  medium: { icon: FaMedium, color: "hover:text-white" },
};

const getSocialIcon = (name) => {
  const key = name.toLowerCase();
  return ICON_MAP[key] || { icon: FaGlobe, color: "hover:text-yellow-400" };
};

const Footer = () => {
  const [socials, setSocials] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/api/admin/allsocial-contact`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setSocials(d.contacts); })
      .catch(() => { });
  }, []);

  return (
    <footer className="bg-gradient-to-b from-[#0f0f0f] via-[#1a1a1a] to-black text-gray-300 relative overflow-hidden">

      {/* GOLD TOP BORDER */}
      <div className="h-[2px] w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600" />

      <div className="max-w-7xl mx-auto px-4 py-16">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">

          {/* BRAND */}
          <div>
            <a href="/home" className="flex items-center gap-3 mb-4">
              <img
                src="/logo.png"
                alt="PrizePulse"
                className="h-10 w-auto"
              />

              <span className="text-2xl font-bold bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 bg-clip-text text-transparent">
                DreamToday
              </span>
            </a>

            <p className="text-gray-400 text-sm mb-5">
              Turning dreams into reality through luxury prize campaigns.
            </p>

            {/* DYNAMIC SOCIAL ICONS */}
            <div className="flex flex-wrap gap-3">
              {socials.length > 0
                ? socials.map((s) => {
                  const { icon: Icon, color } = getSocialIcon(s.name);
                  return (
                    <a
                      key={s._id}
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={s.name}
                      className={`text-yellow-500 transition-colors duration-200 ${color}`}
                    >
                      <Icon size={18} />
                    </a>
                  );
                })
                : /* Fallback static icons while loading */
                [FaFacebook, FaTwitter, FaInstagram, FaYoutube].map((Icon, i) => (
                  <Icon key={i} className="text-yellow-500 opacity-30" size={18} />
                ))
              }
            </div>
          </div>

          {/* ABOUT */}
          <div>
            <h4 className="font-bold mb-4 text-yellow-500">About</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#campaigns" className="hover:text-yellow-500">Campaigns</a></li>
              <li><a href="#how-it-works" className="hover:text-yellow-500">How It Works</a></li>
              <li><a href="#winners" className="hover:text-yellow-500">Winners</a></li>
              <li><a href="#testimonials" className="hover:text-yellow-500">Testimonials</a></li>
            </ul>
          </div>

          {/* SUPPORT */}
          <div>
            <h4 className="font-bold mb-4 text-yellow-500">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faqs" className="hover:text-yellow-500">FAQ</Link></li>
              <li><Link to="/contactus" className="hover:text-yellow-500">Contact Us</Link></li>
              <li><Link to="/terms" className="hover:text-yellow-500">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-yellow-500">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* CAMPAIGNS */}
          <div>
            <h4 className="font-bold mb-4 text-yellow-500">Campaigns</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/campaigns" className="hover:text-yellow-500">Upcoming Campaigns</Link></li>
              <li><Link to="/campaigns" className="hover:text-yellow-500">Current Campaigns</Link></li>
              <li><Link to="/campaigns" className="hover:text-yellow-500">Completed Campaigns</Link></li>
              <li><Link to="/prizes" className="hover:text-yellow-500">Prizes</Link></li>
            </ul>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="pt-6 border-t border-yellow-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2026 DreamToday — Promotional campaigns only.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="hover:text-yellow-500">Privacy</Link>
            <Link to="/terms" className="hover:text-yellow-500">Terms</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;